export const dashboardMenu = [
  "Foundation",
  "Price Optimization",
  "Inventory Optimization",
];

export const foundationNames = [
  "Data Segmentation",
  "Customer Segmentation",
  "Inventory Segmentation",
  "Vendor Segmentation",
  "Data Segmentation (TTM)",
  "Data Segmentation (TTM)_v2",
];

export const priceOptimizationNames = [
  "GMS Opportunity",
  "GM$ Opportunity",
  "Performance",
  "Margin Health",
  "Contract Health",
  "Revenue Variance Analysis",
  "GM$ Variance Analysis",
  "Performance (Beta)",
  "GM$ Variance Analysis",
  "Growth Rate - Developing",
  "Growth Rate",
  "Price Validation",
  "Price Optimization Projection",
];

export const inventoryOptimizationNames = [
  "Asset Efficiency",
  "Inventory Health",
  "Asset Deficiency",
  "Lost Opportunity",
  "Forecast Opportunity",
  "Inventory Opportunity - Developing",
  "Asset Efficiency - Developing",
  "Inventory Simulation - SKU",
];
